// extracted by mini-css-extract-plugin
module.exports = {"formLegend":"FormLegend_formLegend__OMpSm","rotation":"FormLegend_rotation__FVi6U"};